import NonFlexingContainer from '@sport1/news-styleguide/NonFlexingContainer'
import IconButton from '@sport1/news-styleguide/IconButton'
import React from 'react'
import {
    SystemSpacingsProps,
    SpacingsVariants,
    ResponsiveType,
} from '@sport1/news-styleguide/Types'

type IconButtonSize = 'S' | 'M' | 'L' | 'XL'
export type ResponsiveIconButtonSizes = ResponsiveType<IconButtonSize>
interface IconButtonProps extends SystemSpacingsProps {
    icon: 'arrow_back_ios_new' | 'arrow_forward_ios'
    onPress: () => void
    testID?: string
    buttonVariant?: 'primary' | 'secondary' | 'tertiary' | 'highlight'
    arrowMargin?: keyof SpacingsVariants
    arrowButtonSize?: ResponsiveIconButtonSizes
}

const IconButtonArrow = ({
    icon,
    onPress,
    testID,
    buttonVariant,
    arrowMargin,
    arrowButtonSize,
}: IconButtonProps) => {
    const isLeftArrow = icon === 'arrow_back_ios_new'

    return (
        <NonFlexingContainer
            testID={testID}
            position="absolute"
            centerVertical
            left={isLeftArrow ? 0 : undefined}
            right={isLeftArrow ? undefined : 0}
            zIndex={25}
            marginLeft={isLeftArrow ? arrowMargin : 'spacing-none'}
            marginRight={isLeftArrow ? 'spacing-none' : arrowMargin}
            className="top-1/2 transform -translate-y-1/2"
        >
            <IconButton
                iconName={icon}
                buttonType="Filled"
                buttonVariant={buttonVariant || 'primary'}
                buttonSize={arrowButtonSize}
                onPress={onPress}
                testID={`${testID}-icon-${icon}`}
            />
        </NonFlexingContainer>
    )
}

export default IconButtonArrow
